// pages/Register.tsx
import React from "react";

const Register: React.FC = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <h2>Register Page</h2>
    </div>
  );
};

export default Register;
